<span [style]="bmiColor" [matTooltip]="bmiDetails">
    {{bmi | number : '1.0-1' }}
</span>
